// src/analytics.js

/** Pageview para SPA */
export const pageview = (url) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'page_view', {
      page_title: document.title,
      page_location: window.location.href,
      page_path: url,
    });
  }
};

/** Dispara qualquer evento GA4 genérico */
export const gaEvent = (action, params = {}) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', action, params);
  }
};

/** 1) Clique no CTA "Conectar meu grupo" */
export const trackConnectGroupClick = (source = 'unknown') => {
  gaEvent('connect_group_click', { source });
};

/** 2) Login sucesso (dedup por sessão) */
export const trackLoginSuccess = (method = 'unknown') => {
  if (sessionStorage.getItem('ga_login_tracked')) return;
  sessionStorage.setItem('ga_login_tracked', '1');
  gaEvent('login_success', { method });
};

/** 3) Finalização do onboarding (dedup por usuário/dispositivo) */
export const trackOnboardingCompleted = (userId = 'anon') => {
  const key = `ga_onboarded_${userId}`;
  if (localStorage.getItem(key)) return;
  localStorage.setItem(key, '1');
  gaEvent('onboarding_completed', { user_id: String(userId) });
};